// extracted by mini-css-extract-plugin
module.exports = {"HiddenSlide":"carousel-module--HiddenSlide--LM8lC","ShownSlide":"carousel-module--ShownSlide--V6jg5","CarouselSlide":"carousel-module--CarouselSlide--3yE38"};